import MainClass, { MAIN_CLASS_PARAMS } from '../utils/mainClass.ts';

class BFGProfileMasthead extends MainClass {
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.selector && this.init();
	}

	private handleSeeAllPhotos = ( popup: HTMLElement ) => {
		if ( popup ) {
			popup.classList.add( 'open' );
            document.body.classList.add('overflow-hidden');
		}
	};

	private handleClosePopup = (popup: HTMLElement) => {
		if ( popup ) {
			popup.classList.remove( 'open' );
            document.body.classList.remove('overflow-hidden');
			popup.querySelector('.popup-container').scrollTo(0,0)
		}
	};

	private init() {
		const seeAllPhotosBtn = this.selector.querySelector( '.js-see-all-photos' ) as HTMLElement;
		const closePopupBtn = this.selector.querySelector( '.js-close-popup' ) as HTMLElement;
		const allPhotosPopup = this.selector.querySelector( '.js-bfg-image-popup' ) as HTMLElement;
		if ( seeAllPhotosBtn ) {
			seeAllPhotosBtn.addEventListener( 'click', () => this.handleSeeAllPhotos( allPhotosPopup ) );
		}

		if ( closePopupBtn ) {
			closePopupBtn.addEventListener( 'click', () => this.handleClosePopup( allPhotosPopup ) );
		}
	}
}

export default BFGProfileMasthead;
